import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".TextTruncate-module_textTruncate__DOFPf {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.TextTruncate-module_textNotTruncate__bATuQ {\r\n  overflow: visible;\r\n  text-overflow: clip;\r\n  display: block;\r\n  -webkit-line-clamp: none;\r\n  word-wrap: break-word;\r\n}\r\n";
var styles = {"textTruncate":"TextTruncate-module_textTruncate__DOFPf","textNotTruncate":"TextTruncate-module_textNotTruncate__bATuQ"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=TextTruncate.module.css.js.map
